import "../styles/globals.css";
import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import SchedulerApp from "./SchedulerApp";

const elem = document.getElementById("root")!;
const app = (
    <StrictMode>
        <SchedulerApp/>
    </StrictMode>
);

if (import.meta.hot) {
    const root = (import.meta.hot.data.root ??= createRoot(elem));
    root.render(app);
} else {
    createRoot(elem).render(app);
}
